import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetUser, UpdateUser } from "../../../store/user-store/user-actions";
import UserForms from "../../../components/Forms/UserForms";
import { getTokenInfo } from "../../../utils/Guard";

const UserEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (user.id === undefined || user.id === 0) {
      dispatch(GetUser(param.userId, userInfo.Email, true));
    }
  }, [param.userId, userInfo.Email, dispatch, user]);

  return (
    <>
      {user && user.id !== undefined && user.id > 0 && (
        <div
          style={{
            backgroundColor: "#133047",
            padding: "1%",
            height: "62.5rem",
          }}
        >
          <UserForms actionUser={UpdateUser} user={user} />
        </div>
      )}
    </>
  );
};
export default UserEdit;
